(function($, Drupal) {
  "use strict";

  /**
   * Slideout menu.
   */
  Drupal.behaviors.anSlideout = {
    attach: function(context, settings) {

      //console.log('chuj 24');

      $(once('float-btn', '.floating--button--b2b-toggle')).on('click', function() {
        $('.slideout-menu').addClass('slideout-open');
      });

      $(once('slideout-close', '.slideout-close')).on('click', function() {
        $('.slideout-menu').removeClass('slideout-open');
      })


    }
  };

})(jQuery, Drupal);
